export type UseLockedBodyOutput = (locked: boolean) => void;

export const UseSubsPermissionsActionTypes = {
  VALID_PERMISSIONS: "VALID_PERMISSIONS",
  INVALID_PERMISSIONS: "INVALID_PERMISSIONS",
} as const;
